import styled from 'styled-components';
import {device} from '@guestapp/ui/src/utils/device';
import {NumberOfGuestsForm} from 'components/ReservationSettingsModal';

export const StyledNumberOfGuestsForm = styled(NumberOfGuestsForm)`
  & .number-of-guests-form__button {
    margin-top: 48px;
  }

  & .counter-stepper {
    width: 100%;
    max-width: 327px;
    padding: 24px;
    background-color: transparent;
    border-radius: 0;
    margin: 0 auto;
    &:not(:last-of-type) {
      border-bottom: 1px solid #dbdde1;
    }
  }

  @media (max-width: ${device.tablet}) {
    & .counter-stepper {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  @media (min-width: ${device.tablet}) {
    &.multiple-fields {
      & .counter-stepper {
        max-width: 384px;
        background-color: ${({theme}) => theme.colors.branding.boxesModals};
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.07);
        border-radius: 12px;
        border: none;
        position: relative;
        &:first-of-type {
          border-top-left-radius: 12px;
          border-top-right-radius: 12px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        }

        &:last-of-type {
          border-top-left-radius: 0;
          border-top-right-radius: 0;
          border-bottom-left-radius: 12px;
          border-bottom-right-radius: 12px;
        }
      }
    }
  }

  & .number-of-guests-form__button {
    max-width: 327px;
    margin: 48px auto 0;
  }
`;
